import { OptimizedImage } from '@components/optimized-image';
import { createDayNumber, createMonthValue, createWeekDay } from '@utils/format-date/format-date';
import classNames from 'classnames';

import { ImageDateProps } from './image-date.type';

export const ImageDate = ({
  image,
  name,
  date,
  width,
  height,
  round,
  weekDay,
  monthValue,
  dayNumber,
  year,
  timezone,
  dayFont = 'text-date-m text-white',
  monthFont = 'text-date-s text-white',
}: ImageDateProps) => {
  const imageRadius = {
    left: 'rounded-tl-lg rounded-bl-lg',
    right: 'rounded-tr-lg rounded-br-lg',
    top: 'rounded-tr-lg rounded-tl-lg',
    bottom: 'rounded-br-lg rounded-bl-lg',
    full: 'rounded-lg',
  };

  const dateNumber: number = date;
  const tzString: string = timezone ?? '';
  return (
    <>
      <OptimizedImage
        className={classNames('object-cover w-full h-full', round ? imageRadius[round] : '')}
        src={image}
        alt={name}
        width={width}
        height={height}
        dataTestid='image-date'
      />
      <div
        className={classNames(
          'absolute top-0 left-0 w-full h-full shadow-l custom-gradient-overlay z-1',
          round ? imageRadius[round] : ''
        )}>
        <div className='flex items-center uppercase justify-center h-full w-full flex-col'>
          {date && (
            <>
              <p className={classNames('text-white font-black', dayFont as string)}>
                <span data-testid='image-date__day-letter'>{weekDay ?? createWeekDay(dateNumber, tzString)}</span>
                <span data-testid='image-date__day-number'>{dayNumber ?? createDayNumber(dateNumber, tzString)}</span>
              </p>
              <p
                className={classNames('flex whitespace-nowrap text-white font-black', monthFont as string)}
                data-testid='image-date__month'>
                {monthValue ?? createMonthValue(dateNumber, tzString)} {year}
              </p>
            </>
          )}
        </div>
      </div>
    </>
  );
};
